/*
 * Public API Surface of bfsg-accessibility
 */

export * from './lib/bfsg-accessibility.service';
export * from './lib/bfsg-accessibility.module';
export * from './lib/bfsg-accessibility.component';
